import { App } from '../features/home';
import { PageNotFound } from '../features/common';
import _ from 'lodash';
import cancellationRoute from '../features/cancellation/route';
import commonRoute from '../features/common/route';
import enRoutesRoute from '../features/en-routes/route';
import esRoutesRoute from '../features/es-routes/route';
import examplesRoute from '../features/examples/route';
import homeRoute from '../features/home/route';
import myAccountRoute from '../features/my-account/route';
import pagesRoute from '../features/pages/route';
import pbPaymentDetailsRoute from '../features/Pasajebus/PasajebusPaymentDetails/route';
import pbServiceListRoute from '../features/Pasajebus/PasajebusServiceList/route';
import siteMapRoute from '../features/site-map/route';

// NOTE: DO NOT CHANGE the 'childRoutes' name and the declaration pattern.
// This is used for Rekit cmds to register routes config for new features, and remove config when remove features, etc.
const childRoutes = [
  homeRoute,
  commonRoute,
  examplesRoute,
  pbServiceListRoute,
  pbPaymentDetailsRoute,
  myAccountRoute,
  cancellationRoute,
  pagesRoute,
  siteMapRoute,
  esRoutesRoute,
  enRoutesRoute,
];

const routes = [
  {
    path: '/',
    component: App,
    childRoutes: [
      ...childRoutes,
      { path: '*', name: 'Page not found', component: PageNotFound },
    ].filter(r => r.component || (r.childRoutes && r.childRoutes.length > 0)),
  },
];

// Handle isIndex property of route config:
//  Dupicate it and put it as the first route rule.
function handleIndexRoute(route) {
  if (!route.childRoutes || !route.childRoutes.length) {
    return;
  }

  const indexRoute = _.find(route.childRoutes, child => child.isIndex);
  if (indexRoute) {
    const first = { ...indexRoute };
    first.path = '';
    first.exact = true;
    first.autoIndexRoute = true; // mark it so that the simple nav won't show it.
    route.childRoutes.unshift(first);
  }
  route.childRoutes.forEach(handleIndexRoute);
}

routes.forEach(handleIndexRoute);
export default routes;



// WEBPACK FOOTER //
// ./src/common/routeConfig.js